import { useMutation } from 'react-query'

import { expenseRepository } from '@webapp/modules/expense/data-access/repositories/ExpenseRepository'

export const useMutateDenyExpense = () => {
  const mutation = useMutation<void, Error, number>({
    mutationFn: (expenseId) => expenseRepository.deny(expenseId),
  })

  return {
    mutate: mutation.mutateAsync,
    isLoading: mutation.isLoading,
  }
}
